import Container from "@vfuk/core-container";
import Heading from "@vfuk/core-heading";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import { GridColumn, GridRow } from "@vfuk/core-grid";
import Icon from "@vfuk/core-icon";

import type { ReactNode } from "react";
import { Tooltip } from "../Tooltip";

interface FormShellProps {
  title: string;
  subtitle?: string;
  subElement?: ReactNode;
  children: ReactNode;
  tooltipText?: string;
}

const FormShell = ({
  title,
  subtitle,
  subElement,
  children,
  tooltipText,
}: FormShellProps) => {
  return (
    <Container elevation paddingLevel={4}>
      <Heading level={5} weight={3}>
        {title}
        {tooltipText && (
          <>
            &nbsp;
            <Tooltip placement="bottom" content={tooltipText}>
              <span>
                <Icon name="info-circle" />
              </span>
            </Tooltip>
          </>
        )}
      </Heading>
      {(subtitle || subElement) && (
        <GridRow>
          <GridColumn col={6} colMd={8} colLg={8}>
            {subtitle && <Paragraph>{subtitle}</Paragraph>}
          </GridColumn>
          <GridColumn col={6} colMd={4} colLg={4}>
            {subElement}
          </GridColumn>
        </GridRow>
      )}

      <Spacing spacingLevel={{ top: 5 }}>{children}</Spacing>
    </Container>
  );
};

export default FormShell;
